"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = require("./index");
var _TableFooterPagination = _interopRequireDefault(require("./TableFooterPagination.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var TableFooterPagination = function TableFooterPagination(_ref) {
  var checkbox = _ref.checkbox,
    isLoading = _ref.isLoading,
    pagination = _ref.pagination,
    tableFooterTracking = _ref.tableFooterTracking,
    footerActions = _ref.footerActions,
    disableLastPageArrow = _ref.disableLastPageArrow,
    withFormattedData = _ref.withFormattedData;
  return /*#__PURE__*/_react["default"].createElement(_TableFooterPagination["default"], null, /*#__PURE__*/_react["default"].createElement(_index.TableFooterActions, {
    onClear: checkbox ? checkbox.onClear : undefined,
    clearLabel: checkbox ? checkbox.clearLabel : '',
    selectedItems: checkbox ? checkbox.selectedItems.length : 0,
    footerActions: footerActions
  }), /*#__PURE__*/_react["default"].createElement(_index.TablePagination, _extends({}, pagination, {
    tableFooterTracking: tableFooterTracking,
    className: "pagination-wrapper ".concat(pagination.className ? pagination.className : ''),
    isTableLoading: isLoading,
    disableLastPageArrow: disableLastPageArrow,
    withFormattedData: withFormattedData
  })));
};
TableFooterPagination.defaultProps = {
  checkbox: null,
  isLoading: false,
  pagination: null,
  footerActions: [],
  tableFooterTracking: {
    tablePaginationFirst: function tablePaginationFirst() {},
    tablePaginationPrev: function tablePaginationPrev() {},
    tablePaginationNext: function tablePaginationNext() {},
    tablePaginationLast: function tablePaginationLast() {}
  }
};
TableFooterPagination.propTypes = {
  checkbox: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onClear: _propTypes["default"].func,
    clearLabel: _propTypes["default"].string,
    selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    selectAll: _propTypes["default"].func,
    pagesSelected: _propTypes["default"].shape({})
  }),
  isLoading: _propTypes["default"].bool,
  pagination: _propTypes["default"].shape({
    totalResults: _propTypes["default"].number.isRequired,
    resultsPerPage: _propTypes["default"].number.isRequired,
    currentPage: _propTypes["default"].number.isRequired,
    className: _propTypes["default"].string
  }),
  tableFooterTracking: _propTypes["default"].shape({
    tablePaginationFirst: _propTypes["default"].func,
    tablePaginationPrev: _propTypes["default"].func,
    tablePaginationNext: _propTypes["default"].func,
    tablePaginationLast: _propTypes["default"].func
  }),
  footerActions: _propTypes["default"].arrayOf(_propTypes["default"].node),
  disableLastPageArrow: _propTypes["default"].bool.isRequired,
  withFormattedData: _propTypes["default"].bool.isRequired
};
TableFooterPagination.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableFooterPagination",
  "props": {
    "checkbox": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "onChange": {
            "name": "func",
            "required": true
          },
          "onClear": {
            "name": "func",
            "required": false
          },
          "clearLabel": {
            "name": "string",
            "required": false
          },
          "selectedItems": {
            "name": "arrayOf",
            "value": {
              "name": "string"
            },
            "required": true
          },
          "selectAll": {
            "name": "func",
            "required": false
          },
          "pagesSelected": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "isLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "pagination": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "totalResults": {
            "name": "number",
            "required": true
          },
          "resultsPerPage": {
            "name": "number",
            "required": true
          },
          "currentPage": {
            "name": "number",
            "required": true
          },
          "className": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "footerActions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "node"
        }
      },
      "required": false
    },
    "tableFooterTracking": {
      "defaultValue": {
        "value": "{\r\n  tablePaginationFirst: () => {},\r\n  tablePaginationPrev: () => {},\r\n  tablePaginationNext: () => {},\r\n  tablePaginationLast: () => {},\r\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "tablePaginationFirst": {
            "name": "func",
            "required": false
          },
          "tablePaginationPrev": {
            "name": "func",
            "required": false
          },
          "tablePaginationNext": {
            "name": "func",
            "required": false
          },
          "tablePaginationLast": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    },
    "disableLastPageArrow": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "withFormattedData": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    }
  }
};
var _default = TableFooterPagination;
exports["default"] = _default;